module.exports = __webpack_public_path__ + "img/panelView_blackBg_4_3.cb38e4a9.png";